import React from 'react';
import * as SC from './contentSplit.styled';
import { ColorTheme } from '../utils/colorTheme';

interface ContentImageSplitProps {
    leftContent?: React.ReactElement;
    rightContent?: React.ReactElement;
    reverse?: boolean;
    theme?: ColorTheme;
    leftImage?: string;
    rightImage?: string;
    center?: boolean;
    imagePosition?: string;
    leadWithImage?: boolean;
    removeExcessPadding?: boolean;
    verticallyCenterLeft?: boolean;
    verticallyCenterRight?: boolean;
    warning?: string;
}

const ContentSplit: React.FC<ContentImageSplitProps> = (props) => {
    const { leftContent, rightContent, reverse, theme, leftImage, rightImage, center, imagePosition, leadWithImage, removeExcessPadding, verticallyCenterLeft, verticallyCenterRight, warning } = props;
    return (
        <>
            {warning && <SC.Warning>{warning}</SC.Warning>}
             <SC.Banner reverse={reverse} theme={theme} center={center} leadWithImage={leadWithImage}>
                <SC.Content image={leftImage} imagePosition={imagePosition}>
                    {!leftImage && (
                        <SC.Container verticallyCenter={verticallyCenterLeft}>
                            {leftContent}
                        </SC.Container>
                    )}
                </SC.Content>
                <SC.Content image={rightImage} imagePosition={imagePosition} removeExcessPadding={removeExcessPadding}>
                    {!rightImage && (
                        <SC.Container verticallyCenter={verticallyCenterRight}>
                            {rightContent}
                        </SC.Container>
                    )}
                </SC.Content>
            </SC.Banner>
        </>
    )
}

export default ContentSplit;